export default {
    name: 'general-protocol'
};